var sunday = 0,
	monday = 1,
	tuesday = 2,
	wednesday = 3,
	thursday = 4,
	friday = 5,
	saturday = 6,
	fullDay = 1000 * 60 * 60 * 24,
	holidays = {},
	fixedHolidays = [
		{ month: 0, date: 1 },
		{ month: 4, date: 1 },
		{ month: 4, date: 17 },
		{ month: 11, date: 24 },
		{ month: 11, date: 25 },
		{ month: 11, date: 26 }
	];


function euroDayOfWeek(dayOfWeek) {
	if (dayOfWeek === sunday) {
		return 6;
	}
	return dayOfWeek - 1;
}

function usDayOfWeek(dayOfWeek) {
	if (dayOfWeek === 6) {
		return 0;
	}
	return dayOfWeek + 1;
}

function findNextWorkday(day) {
	var euroDay = euroDayOfWeek(day),
		nextWorkday = euroDay + 1;
	if (nextWorkday > 4) {
		nextWorkday = 0;
	}
	return usDayOfWeek(nextWorkday);
}

function findEaster(year) {
	// http://en.wikipedia.org/wiki/Computus#Anonymous_Gregorian_algorithm
	var a = year % 19,
		b = Math.floor(year / 100.0),
		c = year % 100,
		d = Math.floor(b / 4.0),
		e = b % 4,
		f = Math.floor((b + 8) / 25.0),
		g = Math.floor((b - f + 1) / 3.0),
		h = (19 * a + b - d - g + 15) % 30,
		i = Math.floor(c / 4.0),
		k = c % 4,
		l = (32 + 2 * e + 2 * i - h - k) % 7,
		m = Math.floor((a + 11 * h + 22 * l) / 451.0),
		month = Math.floor((h + l - 7 * m + 114) / 31.0) - 1,
		day = ((h + l - 7 * m + 114) % 31) + 1;
	return new Date(year, month, day);
}

function findChurchHolidays(year) {
	var easterSunday = findEaster(year),
		easterValue = easterSunday.valueOf(),
		easterHolidays = [
			new Date(easterValue - 3 * fullDay),
			new Date(easterValue - 2 * fullDay),
			new Date(easterValue + 1 * fullDay),
			new Date(easterValue + 39 * fullDay),
			new Date(easterValue + 49 * fullDay),
			new Date(easterValue + 50 * fullDay)
		];
	return easterHolidays;
}

function findAllHolidays(year) {
	var easterHolidays = findChurchHolidays(year),
		allHolidays = $.merge(
			easterHolidays,
			$.map(fixedHolidays, function (e) {
				return new Date(year, e.month, e.date);
			})
		);
	return allHolidays;
}

function isHoliday(testDate) {
	var yearKey = testDate.getFullYear().toString();
	if (holidays[yearKey] === undefined) {
		holidays[yearKey] = findAllHolidays(testDate.getFullYear());
	}
	return $.grep(holidays[yearKey], function (e) {
		return testDate.getMonth() === e.getMonth() &&
				testDate.getDate() === e.getDate();
	}).length > 0;
}

function skipIfHolidayOrWeekEnd(date) {
	while (isHoliday(date) || euroDayOfWeek(date.getDay()) > 4) {
		date = new Date(date.valueOf() + fullDay);
	}
	return date;
}

function findNextWorkdayDate(date, addHours) {
	var nextWorkday, nextWorkdayDate;
	addHours = addHours || 12;
	date = new Date(date.valueOf() + addHours * 60 * 60 * 1000);
	date = skipIfHolidayOrWeekEnd(date);
	nextWorkday = findNextWorkday(date.getDay());
	nextWorkdayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	while (nextWorkdayDate.getDay() !== nextWorkday) {
		nextWorkdayDate = new Date(nextWorkdayDate.valueOf() + fullDay);
	}
	nextWorkdayDate = skipIfHolidayOrWeekEnd(nextWorkdayDate);
	return nextWorkdayDate;
}

export default {
	Monday: monday,
	Tuesday: tuesday,
	Wednesday: wednesday,
	Thursday: thursday,
	Friday: friday,
	Saturday: saturday,
	Sunday: sunday,
	findNextWorkday: findNextWorkday,
	findEaster: findEaster,
	findChurchHolidays: findChurchHolidays,
	findNextWorkdayDate: findNextWorkdayDate,
	findAllHolidays: findAllHolidays,
	isHoliday: isHoliday
};
